/**
 * CMS Master-specific translation keys
 */
export const cms = {
  list: {
    main_heading: "admin.cms_list_heading",
    no_permission_to_view: "admin.cms_no_permission_to_view",
    search_placeholder: "admin.cms_search_placeholder",
    clear_filter_btn_text: "admin.cms_clear_filter_btn_text",
    status_toggle_tooltip: "admin.cms_status_toggle_tooltip",
    status_popup_heading_text: "admin.cms_status_popup_heading_text",
    status_popup_yes_btn_text: "admin.cms_delete_popup_yes_btn_text",
    status_popup_no_btn_text: "admin.cms_delete_popup_no_btn_text",
    table: {
      created_at_table_col_heading: "admin.cms_created_at_table_col_heading",
      slug_table_col_heading: "admin.cms_slug_table_col_heading",
      version_table_col_heading: "admin.cms_version_table_col_heading",
      status_table_col_heading: "admin.cms_status_table_col_heading",
      title_table_col_heading: "admin.cms_title_table_col_heading",
      updated_at_table_col_heading: "admin.cms_updated_at_table_col_heading",
      action_table_col_heading: "admin.cms_action_table_col_heading",
    },
    add_btn_text: "admin.cms_add_btn_text",
    delete_tooltip: "admin.cms_delete_tooltip",
    delete_popup_heading_text: "admin.cms_delete_popup_heading_text",
    delete_popup_yes_btn_text: "admin.cms_delete_popup_yes_btn_text",
    delete_popup_no_btn_text: "admin.cms_delete_popup_no_btn_text",
    edit_tooltip: "admin.cms_edit_tooltip",
    no_content_badge: "admin.cms_no_content_badge",
  },
  add: {
    main_heading: "admin.cms_add_heading",
  },
  edit: {
    main_heading: "admin.cms_edit_heading",
    not_found: "admin.cms_not_found",
    loading: "admin.cms_loading",
  },
  form: {
    seo_meta_title_label: "admin.cms_seo_meta_title_label",
    seo_meta_title_placeholder: "admin.cms_seo_meta_title_placeholder",
    seo_meta_desc_label: "admin.cms_seo_meta_desc_label",
    seo_meta_desc_placeholder: "admin.cms_seo_meta_desc_placeholder",
    status_label: "admin.cms_status_label",
    status_active: "admin.cms_status_active",
    status_inactive: "admin.cms_status_inactive",
    slug_label: "admin.cms_slug_label",
    version_label: "admin.cms_version_label",
    version_placeholder: "admin.cms_version_placeholder",
    version_hint: "admin.cms_version_hint",
    slug_placeholder: "admin.cms_slug_placeholder",
    slug_locked_hint: "admin.cms_slug_locked_hint",
    add_submit_btn_text: "admin.cms_add_submit_btn_text",
    title_label: "admin.cms_title_label",
    title_placeholder: "admin.cms_title_placeholder",
    content_label: "admin.cms_content_label",
    optional_hint: "admin.cms_optional_language_hint",
    submit_btn_text: "admin.cms_submit_btn_text",
    cancel_btn_text: "admin.cms_cancel_btn_text",
    loading_btn_text: "admin.cms_loading_btn_text",
  },
};
